import React from 'react';
import { Field, Form } from 'react-final-form';
import FieldTextInput from 'Components/FormFields/FieldTextInput';
import { OnSubmitReturnType } from 'Interfaces/FinalForm';
import { composeValidators } from 'Utils/functions';
import {
  maxLength100,
  notOnlySpaces,
  required,
  titleNotUrlProtocol,
} from 'Utils/validation';

interface RenameTitleFormProps {
  documentTitle: string;
  onSubmit: ({ title: string }) => OnSubmitReturnType;
}
const EditableTitle = ({ documentTitle, onSubmit }: RenameTitleFormProps) => {
  return (
    <Form
      onSubmit={onSubmit}
      initialValues={{ title: documentTitle }}
      render={({ handleSubmit }) => (
        <form onSubmit={handleSubmit}>
          <Field
            name="title"
            component={FieldTextInput}
            autofocus
            hidden
            validate={composeValidators<string>(
              required,
              notOnlySpaces,
              maxLength100,
              titleNotUrlProtocol,
            )}
          />
        </form>
      )}
    />
  );
};
export default EditableTitle;
